import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetSalesObjectionContext as GetSalesObjectionContextQuery} from 'nutshell-graphql-types';

import {generateContextString} from '../../helpers';

import GET_SALES_OBJECTION_CONTEXT from '../queries/get-sales-objection-context.graphql';

export const useGetSalesObjectionContext = (): {
    context: string | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetSalesObjectionContextQuery,
        Record<any, any>
    >(GET_SALES_OBJECTION_CONTEXT, {});

    return {
        context: generateContextString(data),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
